import { render, staticRenderFns } from "./ReportStateChanges.vue?vue&type=template&id=09e27ce7&"
import script from "./ReportStateChanges.vue?vue&type=script&lang=js&"
export * from "./ReportStateChanges.vue?vue&type=script&lang=js&"
import style0 from "./ReportStateChanges.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QIcon,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign({QTable,QIcon,QTr,QTh,QTd}, component.options.components || {})
